import { notify } from '@tiger/bugsnag';
import { Logger } from '@tiger/logger';
import { Component } from 'react';
import { findDOMNode } from 'react-dom';

const win = window;

/**
 * @description
 * 滚动到顶部，并且支持记忆之前浏览位置
 *
 * 只滚动到顶部，默认整个页面
 * <ScrollTop />
 *
 * 滚动到指定节点位置
 * <ScrollTop to="#header" />
 *
 * 增加一个id属性，首次滚动到顶部，后面可以滚动到上次浏览位置
 * <ScrollTop id="xxx" />
 *
 * 传递parent=true属性，则会将组件的父级作为滚动容器
 * <ScrollTop parent />
 *
 * 也可以传递一个字符串，其作为节点选择器用来指定滚动容器
 * <ScrollTop parent=".css-selector" />
 */
class ScrollTop extends Component<{
    parent?: boolean | string;
    id?: string;
    to?: string | HTMLElement;
}> {
    positionKey: string;
    parentNode: any;
    componentDidMount() {
        try {
            const { id, to } = this.props;
            const portalHeader = document.querySelector('#header') || document.querySelector('.site-header');

            let prevPosition = 0;
            let targetPosition = 0;

            if (id) {
                this.positionKey = `scroll-to-top-${id}`;
                // @ts-ignore
                prevPosition = sessionStorage.getItem(this.positionKey) * 1 || 0;
            }

            this.parentNode =
                typeof this.props.parent === 'string'
                    ? document.querySelector(this.props.parent)
                    : this.props.parent
                    ? findDOMNode(this)!.parentNode
                    : win;

            if (to) {
                const targetNode = typeof to === 'string' ? document.querySelector(to) : to;
                const targetTop = targetNode?.getBoundingClientRect().top || 0;
                // 目标节点是否已经被遮挡
                const isTargetVisible = targetTop > Math.max(0, portalHeader?.getBoundingClientRect().bottom || 0);
                const scrollY = this.parentNode.scrollTop ?? this.parentNode.scrollY;

                if (isTargetVisible) {
                    targetPosition = scrollY;
                } else {
                    if (targetNode) {
                        const headerHeight = Math.max(portalHeader?.getBoundingClientRect().bottom || 0, 0);

                        targetPosition = targetTop + scrollY - headerHeight;
                    }
                }

                if (process.env.NODE_ENV !== 'production' && this.props.parent) {
                    Logger.error(
                        new Error(`'to' 只能用于全局body页面滚动，不可以与 'parent' 同时调用！`),
                        'components/ScrollTop'
                    );
                }
            }

            if (win === this.parentNode) {
                win.scrollTo(0, prevPosition || targetPosition);
            } else {
                this.parentNode.scrollTop = prevPosition || targetPosition;
            }
        } catch (error) {
            notify(error);
        }
    }

    componentWillUnmount() {
        if (this.props.id) {
            sessionStorage.setItem(this.positionKey, win === this.parentNode ? win.scrollY : this.parentNode.scrollTop);
        }
    }

    render() {
        return null;
    }
}

export default ScrollTop;
